import { FC, HTMLAttributes, useEffect, useState } from "react";
import { StaticImage } from "../StaticImage";
import { useStyles } from "./GameFeed.style";
import useInView from "../../../hooks/useInView";
import useResizeScreen from "../../../hooks/useResizeScreen";

interface IMediaFeedProps {
  video?: string;
  background: string;
}

export const MediaFeed: FC<
  IMediaFeedProps & HTMLAttributes<HTMLDivElement>
> = ({ video, background, ...props }) => {
  const classes = useStyles();
  const [shouldPlayVideo, setShouldPlayVideo] = useState(false);
  const [hasPlayedOnce, setHasPlayedOnce] = useState(false);
  const { ref, inView } = useInView();
  const screenHeight = useResizeScreen();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (inView && video && !hasPlayedOnce) {
      timer = setTimeout(() => {
        setShouldPlayVideo(true);
      }, 2000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [inView, video, hasPlayedOnce]);

  const showVideo = !!(shouldPlayVideo && video);

  const handleVideoEnded = () => {
    setShouldPlayVideo(false);
    setHasPlayedOnce(true);
  };

  const handlePlayClick = () => {
    setShouldPlayVideo(true);
  };

  return (
    <div ref={ref} className={props.className}>
      {showVideo ? (
        <video
          src={video}
          className={classes.featureImage}
          style={{ height: screenHeight }}
          autoPlay
          muted
          playsInline
          preload="auto"
          onEnded={handleVideoEnded}
        />
      ) : (
        <div
          style={{
            position: "relative",
            height: screenHeight,
          }}
        >
          <StaticImage
            src={background}
            className={classes.featureImage}
            style={{ height: "100%" }}
          />

          {hasPlayedOnce && video && (
            <button
              type="button"
              onClick={handlePlayClick}
              className={classes.playBtn}
            >
              <div className={classes.iconBtn}>▶</div>
            </button>
          )}
        </div>
      )}
    </div>
  );
};
